import { useT } from "../../i18n/I18nProvider";
import { useExceptions } from "./queries-frontdesk";

/** The number of folios billing refused, in the sidebar. Nothing is drawn while there are none or the count is unknown. */
export function ExceptionsBadge() {
  const t = useT();
  const exceptions = useExceptions();
  const waiting = exceptions.data?.folios.length ?? 0;
  if (waiting === 0) return null;
  return (
    <span className="cc-nav__badge">
      <span aria-hidden="true">{waiting > 99 ? "99+" : waiting}</span>
      <span className="sr-only">{t("lodging.nav.exceptionsWaiting", { count: waiting })}</span>
    </span>
  );
}
